"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var Footer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Footer, _React$Component);

  function Footer() {
    (0, _classCallCheck2.default)(this, Footer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Footer).apply(this, arguments));
  }

  (0, _createClass2.default)(Footer, [{
    key: "render",
    value: function render() {
      var year = new Date().getFullYear().toString();
      var footerClassNames = (0, _classnames.default)({
        fixed: this.props.isFixed
      });
      return _react.default.createElement("footer", {
        className: footerClassNames
      }, _react.default.createElement("div", {
        className: "wsg-container"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "footer.poweredBy",
        options: {
          year: year
        }
      })));
    }
  }]);
  return Footer;
}(_react.default.Component);

exports.default = Footer;
Footer.propTypes = {
  isFixed: _propTypes.default.bool
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/footer/Footer.js
// module id = 162
// module chunks = 0